import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, Button, CircularProgress, Alert } from "@mui/material";
import { Save, RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
const DEFAULT_POLICY = `Privacy Policy

Last updated: ${new Date().getFullYear()}

1. Introduction
We are committed to protecting your personal information and your right to privacy. This policy explains how we collect, use, and safeguard your information when you visit our website or place an order.

2. Information We Collect
We may collect the following information when you interact with our website:
- Name and contact details (phone number, email address)
- Order details and purchase history
- Messages and inquiries you send us

3. How We Use Your Information
We use the information we collect to:
- Process and fulfill your orders
- Contact you regarding your orders or inquiries
- Improve our products and services
- Comply with legal obligations

4. Information Sharing
We do not sell or trade your personal information. We may share it only as necessary to fulfill your orders (e.g., delivery partners) or as required by law.

5. Data Security
We apply appropriate technical and organizational measures to protect your personal data against unauthorized access, loss, or misuse.

6. Cookies
Our website may use cookies to enhance your experience. You can disable cookies through your browser settings at any time.

7. Your Rights
You have the right to request access to, correction of, or deletion of the personal data we hold about you. Contact us through our contact page to exercise these rights.

8. Contact Us
If you have questions about this Privacy Policy, please reach out via the Contact page on our website.`;
const PrivacyPolicyTab = ({
  settings,
  save,
  saving
}) => {
  const {
    t
  } = useTranslation("website");
  const [content, setContent] = useState("");
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    if (settings) {
      setContent(settings.privacyPolicyContent || DEFAULT_POLICY);
    }
  }, [settings]);
  const handleSave = async () => {
    await save({
      privacyPolicyContent: content
    });
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };
  const handleReset = () => {
    if (window.confirm(t("Reset to the default privacy policy text?"))) {
      setContent(DEFAULT_POLICY);
    }
  };
  return <Box>
      <Typography variant="body2" color="text.secondary" sx={{
      mb: 1
    }}>{t("This content is displayed on your public Privacy Policy page at")}
        {" "}
        <strong>/w/{settings?.slug}/privacy-policy</strong>{t(". Edit the text below to match your business. Plain text only — line breaks are preserved.")}


      </Typography>

      {saved && <Alert severity="success" sx={{
      mb: 2
    }}>{t("Privacy policy saved successfully.")}

      </Alert>}

      <TextField multiline fullWidth minRows={24} value={content} onChange={e => setContent(e.target.value)} variant="outlined" inputProps={{
      style: {
        fontFamily: "monospace",
        fontSize: "0.875rem",
        lineHeight: 1.7
      }
    }} sx={{
      mb: 2
    }} />
      

      <Box sx={{
      display: "flex",
      gap: 1.5
    }}>
        <Button variant="contained" onClick={handleSave} disabled={saving} startIcon={saving ? <CircularProgress size={16} /> : <Save size={16} />}>{t("Save Privacy Policy")}


        </Button>
        <Button variant="outlined" color="inherit" onClick={handleReset} startIcon={<RotateCcw size={16} />}>{t("Reset to Default")}


        </Button>
      </Box>
    </Box>;
};
export default PrivacyPolicyTab;
